import { DetailSummary } from "@/shared/components/ui/DetailSummary";
import { Section } from "@/shared/components/ui/Section";
import type { Form } from "../types/formTypes";

export function FormMetadata({ form }: { form: Form }) {
  return (
    <Section title="Form details" card>
      <DetailSummary items={[
        { label: "Version", value: form.version },
        { label: "Form ID", value: form.id },
        { label: "Business ID", value: form.businessId },
        { label: "Created", value: form.createdAt.toLocaleString() },
        { label: "Created by", value: form.createdBy },
        { label: "Updated", value: form.modifiedAt.toLocaleString() },
        { label: "Updated by", value: form.modifiedBy },
        { label: "Version ID", value: form.versionId },
        { label: "Version created", value: form.versionCreatedAt.toLocaleString() },
        { label: "Version created by", value: form.versionCreatedBy },
      ]} />
      <p className="text-xs leading-relaxed text-muted-foreground">Version and metadata are managed automatically. Only the latest version is shown.</p>
    </Section>
  );
}
